import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { ChangeEventArgs } from '@syncfusion/ej2-angular-richtexteditor';
import { ConfirmService } from 'src/app/libs/confirm/confirm.service';

@Component({
  selector: 'app-texto-editor',
  templateUrl: './texto-editor.component.html',
  styleUrls: ['./texto-editor.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextoEditorComponent),
      multi: true
    }
  ]
})
export class TextoEditorComponent implements OnInit, ControlValueAccessor {

  @Input()
  label: string = '';

  public tools: object = {
    items: [
      'Bold', 'Italic', 'Underline', 'StrikeThrough', '|',
      'ClearFormat', 'Print', 'SourceCode', '|', 'FullScreen', '|',
      {
        tooltipText: 'Carregar Último Texto',
        id: 'update',
        prefixIcon: 'e-icons fa fas fa-sync'
      }, 'Undo', 'Redo'
    ]
  };

  @Input()
  textoResete: string | null = null;

  @Input()
  height: string = '320px';

  @Input()
  formControl: FormControl | null = null;

  @Input()
  formControlName: string | null = null;

  value: string | null = null;

  constructor(private confirm: ConfirmService) { }

  ngOnInit(): void {
  }

  onChange: any = () => { };
  onTouched: any = () => { };

  writeValue(obj: any): void {
    this.value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {

  }

  change(args: ChangeEventArgs) {
    this.onChange(args.value);
  }

  toolbarClick(args: ClickEventArgs) {
    if (args.item.id === 'update') {
      this.confirm.confirm().subscribe((val) => {
        if (val) {
          this.value = this.textoResete;
          this.onChange(this.textoResete);
        }
      });
    }
  }
}
